import { documentReady } from 'gaspard'
import getScript from './getScript'
import dataLayer from '../core/dataLayer'

function initYouTubeIframeAPI (resolve) {
    window.onYouTubeIframeAPIReady = () => resolve()
    getScript('https://www.youtube.com/iframe_api')
}

class YtPlayer {
    constructor () {
        this.iframeApi = new Promise(resolve => {
            dataLayer.ready.then(({ isClassic }) => {
                if (isClassic) {
                    documentReady(() => initYouTubeIframeAPI(resolve))
                } else {
                    initYouTubeIframeAPI(resolve)
                }
            })
        })
    }
    attach (iframeContainer, videoId, isBackgroundVideoPlaying, isAutoPlay = 1, moreParams = {}) {
        let params = {}
        if (isBackgroundVideoPlaying) {
            params = {
                playlist: videoId,
                controls: 0,
                loop: 1
            }
        }
        return new Promise(resolve => {
            this.iframeApi.then(() => {
                const player = new window.YT.Player(iframeContainer, {
                    videoId,
                    playerVars: {
                        // disablekb: 1,
                        // showinfo: 0,
                        // modestbranding: 1,
                        rel: 0,
                        fs: 0,
                        autoplay: isAutoPlay,
                        ...params,
                        ...moreParams
                    },
                    events: {
                        onReady: () => {
                            if (isBackgroundVideoPlaying) {
                                player.mute()
                            }
                            resolve(player)
                        },
                        onStateChange: (event) => {},
                        onError: (event) => {}
                    }
                })
            })
        })
    }
}

export default new YtPlayer()



// WEBPACK FOOTER //
// ./node_modules/nespresso-library/src/utils/ytPlayer.js